export default __webpack_public_path__ + "static/media/pencil.b5ddec05.mp3";